// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-screening-table[data-v-37863596]{--title-line-height:32px;--title-font-size:24px;--title-height:44px}.title-wrapper[data-v-37863596]{display:flex}", ""]);
// Exports
module.exports = exports;
